import type { SVGProps } from 'react';
import { clsx } from 'clsx';
import styles from './decorative-equities-icon.module.scss';

interface DecorativeEquitiesIconProps extends SVGProps<SVGSVGElement> {
  fill: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
}

export function DecorativeEquitiesIcon({ className, fill, ...props }: DecorativeEquitiesIconProps) {
  return (
    <svg className={clsx(styles.decorativeEquitiesIcon, className)} fill="none" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Trading Chart icon</title>

      <path
        className={styles[`fill-${fill}`]}
        clipRule="evenodd"
        d="M15 5.8V12.9982C15 14.9312 13.433 16.4982 11.5 16.4982H4.5C2.567 16.4982 1 14.9312 1 12.9982V10.3782H2.5V10.383L3.61426 8.60078C3.73538 8.40705 3.93802 8.27901 4.16504 8.25313C4.39213 8.22727 4.61866 8.30636 4.78027 8.46797L6.61426 10.301L8.61426 7.10078C8.73538 6.90705 8.93803 6.77901 9.16504 6.75313C9.39213 6.72727 9.61866 6.80636 9.78027 6.96797L11.6143 8.80098L13.4893 5.8H15Z"
        fillRule="evenodd"
        opacity="0.2"
      />

      <path
        clipRule="evenodd"
        d="M11.5 1C13.433 1 15 2.567 15 4.5V11.5C15 13.433 13.433 15 11.5 15H4.5C2.567 15 1 13.433 1 11.5V4.5C1 2.567 2.567 1 4.5 1H11.5ZM12.3857 8.89746C12.2646 9.0912 12.062 9.21923 11.835 9.24512C11.6079 9.27098 11.3813 9.19189 11.2197 9.03027L9.38672 7.19629L7.38574 10.3975C7.26462 10.5912 7.06198 10.7192 6.83496 10.7451C6.60787 10.771 6.38134 10.6919 6.21973 10.5303L4.38672 8.69629L2.50977 11.6973L2.51074 11.7041C2.613 12.7128 3.46435 13.5 4.5 13.5H11.5C12.5357 13.5 13.387 12.7128 13.4893 11.7041L13.5 11.5V7.11426L12.3857 8.89746ZM4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8.88477L3.61426 7.10254C3.73538 6.9088 3.93802 6.78077 4.16504 6.75488C4.39213 6.72902 4.61866 6.80811 4.78027 6.96973L6.61426 8.80273L8.61426 5.60254C8.73538 5.4088 8.93803 5.28077 9.16504 5.25488C9.39213 5.22902 9.61866 5.30811 9.78027 5.46973L11.6143 7.30273L13.4893 4.30176C13.3897 3.2903 12.5376 2.5 11.5 2.5H4.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
